module.exports = __webpack_public_path__ + "static/media/castel-cafe.931e228d.jpg";